import theme from '@/shared/theme';
import { ICourseData } from '../types/course-data';
import { CourseType } from '../types/course';

// Define the ColorScheme interface that matches the expected structure
export interface ColorScheme {
  card: { text: string; bg: string };
  courseTypeTag: { text: string; bg: string };
  musicalGenre: { text: string; border: string };
  skillLevel: { text: string; bg: string };
  avatar: { border: string };
  modal: {
    courseTypeTag: { text: string; bg: string };
    text: string;
    itemBg: string;
  };
}

const highlightedCourses = {
  serie: {
    cardBg: theme.palette.primary.dark,
    courseTypeChipBg: theme.palette.primary.contrastText,
    courseTypeChipTextColor: theme.palette.primary.dark,
    cardTextColor: theme.palette.primary.contrastText,
    courseLevelChipBgColor: theme.palette.primary.contrastText,
    courseLevelChipTextColor: theme.palette.primary.main,
    genreChipColor: theme.palette.primary.contrastText,
  },
  percorsi: {
    cardBg: theme.palette.complementary.main,
    courseTypeChipBg: theme.palette.primary.contrastText,
    courseTypeChipTextColor: theme.palette.complementary.dark,
    cardTextColor: theme.palette.complementary.contrastText,
    courseLevelChipBgColor: theme.palette.complementary.contrastText,
    courseLevelChipTextColor: theme.palette.complementary.main,
    genreChipColor: theme.palette.complementary.contrastText,
  },
  masterclass: {
    cardBg: theme.palette.secondary.main,
    courseTypeChipBg: theme.palette.primary.contrastText,
    courseTypeChipTextColor: theme.palette.secondary.dark,
    cardTextColor: theme.palette.secondary.contrastText,
    courseLevelChipBgColor: theme.palette.secondary.contrastText,
    courseLevelChipTextColor: theme.palette.secondary.main,
    genreChipColor: theme.palette.secondary.contrastText,
  },
};

const regularCourses = {
  serie: {
    cardBg: theme.palette.paper.main,
    courseTypeChipBg: theme.palette.primary.main,
    courseTypeChipTextColor: theme.palette.primary.contrastText,
    cardTextColor: theme.palette.primary.contrastText,
    courseLevelChipBgColor: theme.palette.neutral.main,
    courseLevelChipTextColor: theme.palette.primary.contrastText,
    genreChipColor: theme.palette.primary.contrastText,
  },
  percorsi: {
    cardBg: theme.palette.paper.main,
    courseTypeChipBg: theme.palette.complementary.main,
    courseTypeChipTextColor: theme.palette.complementary.contrastText,
    cardTextColor: theme.palette.primary.contrastText,
    courseLevelChipBgColor: theme.palette.neutral.main,
    courseLevelChipTextColor: theme.palette.primary.contrastText,
    genreChipColor: theme.palette.primary.contrastText,
  },
  masterclass: {
    cardBg: theme.palette.paper.main,
    courseTypeChipBg: theme.palette.secondary.main,
    courseTypeChipTextColor: theme.palette.secondary.contrastText,
    cardTextColor: theme.palette.primary.contrastText,
    courseLevelChipBgColor: theme.palette.neutral.main,
    courseLevelChipTextColor: theme.palette.primary.contrastText,
    genreChipColor: theme.palette.primary.contrastText,
  },
};

export const generateCourseColorScheme = (highlighted: boolean, type: CourseType): ColorScheme => {
  return {
    courseTypeTag: {
      bg: highlighted
        ? highlightedCourses[type].courseTypeChipBg || ''
        : regularCourses[type].courseTypeChipBg || '',
      text: highlighted
        ? highlightedCourses[type].courseTypeChipTextColor || ''
        : regularCourses[type].courseTypeChipTextColor || '',
    },
    card: {
      bg: highlighted ? highlightedCourses[type].cardBg || '' : regularCourses[type].cardBg || '',
      text: highlighted
        ? highlightedCourses[type].cardTextColor || ''
        : regularCourses[type].cardTextColor || '',
    },
    musicalGenre: {
      border: highlighted
        ? highlightedCourses[type].genreChipColor || ''
        : regularCourses[type].genreChipColor || '',
      text: highlighted
        ? highlightedCourses[type].courseTypeChipTextColor || ''
        : regularCourses[type].genreChipColor || '',
    },
    skillLevel: {
      bg: highlighted
        ? highlightedCourses[type].courseLevelChipBgColor || ''
        : regularCourses[type].courseLevelChipBgColor || '',
      text: highlighted
        ? highlightedCourses[type].courseLevelChipTextColor || ''
        : regularCourses[type].courseLevelChipTextColor || '',
    },
    avatar: {
      border: highlighted
        ? highlightedCourses[type].cardBg || ''
        : regularCourses[type].cardBg || '',
    },
    modal: {
      courseTypeTag: {
        bg: highlighted
          ? highlightedCourses[type].courseTypeChipBg || ''
          : regularCourses[type].courseTypeChipBg || '',
        text: highlighted
          ? highlightedCourses[type].courseTypeChipTextColor || ''
          : regularCourses[type].courseTypeChipTextColor || '',
      },
      text: theme.palette.text.primary || '',
      itemBg: theme.palette.neutral.main || '',
    },
  };
};
